"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compareStrings = void 0;
var constants_1 = require("../constants");
var compareStrings = function (str1, str2, options) {
    if (options === void 0) { options = {}; }
    if (typeof str1 !== 'string' || typeof str2 !== 'string') {
        return false;
    }
    var ignoreCase = options.ignoreCase;
    var collatorOptions;
    if (typeof ignoreCase === 'boolean') {
        var sensitivity = ignoreCase ? constants_1.CollatorSensitivity.BASE : constants_1.CollatorSensitivity.CASE;
        collatorOptions = { sensitivity: sensitivity };
    }
    return str1.localeCompare(str2, undefined, collatorOptions) === 0;
};
exports.compareStrings = compareStrings;
